// src/AuthContext.js
import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

const getStoredSession = () => {
  const session = sessionStorage.getItem("studentSession");
  return session ? JSON.parse(session) : null;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => getStoredSession());

  useEffect(() => {
    setUser(getStoredSession());
  }, []);

  const login = (data) => {
    sessionStorage.setItem("studentSession", JSON.stringify(data));
    setUser(data);
  };

  const logout = () => {
    sessionStorage.removeItem("studentSession");
    setUser(null);
  };

  const updateUser = (updates) => {
    setUser((currentUser) => {
      const nextUser = {
        ...(currentUser || {}),
        ...updates,
      };

      sessionStorage.setItem("studentSession", JSON.stringify(nextUser));
      return nextUser;
    });
  };

  return (
    <AuthContext.Provider
      value={{ user, token: user?.token, login, logout, updateUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};
